import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.config.errorHandler = (error, _instance, info) => {
  console.error('Global error:', error, info)
}

app.mount('#app')
